import { useState } from 'react';
import { GoCheck } from 'react-icons/go';
import { IoIosArrowDown } from 'react-icons/io';
import SlidingModal from '../home/mobile/SlidingModal';
export default function TimeFrameSelector({
  timeFrame,
  setTimeFrame,
  textBlack = false
}) {
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const liClass = 'h-[48px] border-genius-blue items-center flex cursor-pointer px-6 ta-c';
  return <div className='border-genius-blue' data-sentry-component="TimeFrameSelector" data-sentry-source-file="TimeFrameSelector.tsx">
      <div onClick={toggleModal} className={`flex items-center justify-between  ${textBlack ? 'text-genius-blue' : 'text-genius-cream'}  gap-4  px-1 md:px-4 py-0.5 rounded-md cursor-pointer`}>
        <p className='text-xs md:text-base'>{timeFrame}H</p>
        <IoIosArrowDown className='h-4 w-4 ml-3' data-sentry-element="IoIosArrowDown" data-sentry-source-file="TimeFrameSelector.tsx" />
      </div>

      <SlidingModal isOpen={isModalOpen} onClose={toggleModal} heightFit={true} data-sentry-element="SlidingModal" data-sentry-source-file="TimeFrameSelector.tsx">
        <div className={`pb-0 text-sm ta-l w-full mt-2`}>
          <ul>
            <li className={liClass} onClick={() => {
            setTimeFrame('24');
            toggleModal();
          }}>
              24H {timeFrame === '24' && <GoCheck className='h-4 w-4 ml-4' />}
            </li>
            <li className={liClass} onClick={() => {
            setTimeFrame('12');
            toggleModal();
          }}>
              12H {timeFrame === '12' && <GoCheck className='h-4 w-4 ml-4' />}
            </li>
            <li className={liClass} onClick={() => {
            setTimeFrame('4');
            toggleModal();
          }}>
              4H {timeFrame === '4' && <GoCheck className='h-4 w-4 ml-4' />}
            </li>
            <li className={liClass} onClick={() => {
            setTimeFrame('1');
            toggleModal();
          }}>
              1H {timeFrame === '1' && <GoCheck className='h-4 w-4 ml-4' />}
            </li>
          </ul>
        </div>
      </SlidingModal>
    </div>;
}